import { render, staticRenderFns } from "./AddMemberSidebar.vue?vue&type=template&id=2553b39f&scoped=true&"
import script from "./AddMemberSidebar.vue?vue&type=script&lang=js&"
export * from "./AddMemberSidebar.vue?vue&type=script&lang=js&"
import style0 from "./AddMemberSidebar.vue?vue&type=style&index=0&id=2553b39f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2553b39f",
  null
  
)

export default component.exports